import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";

const normalizeResult = (result) => {
    if (!result || typeof result !== "object") {
        return {};
    }
    return result;
};

function ImportSummary({ result, onClose, showCloseButton = true }) {
    const { t } = useTranslation();
    const normalizedResult = normalizeResult(result);
    const resultKeys = Object.keys(normalizedResult);

    if (!resultKeys.length) {
        return (
            <div className="d-flex flex-column gap-3">
                <div className="text-muted">{t("no-data")}</div>
                {showCloseButton && (
                    <Button color="danger" className="w-100" onClick={onClose}>
                        {t("close")}
                    </Button>
                )}
            </div>
        );
    }

    return (
        <div>
            {resultKeys.map((employeeNumber) => {
                const { status, message, ...rows } = normalizedResult[employeeNumber];
                const { inserted, failed } = Object.entries(rows).reduce(
                    (total, [row, value]) => {
                        if (value.status) {
                            total.inserted[row] = value;
                        } else {
                            total.failed[row] = value;
                        }
                        return total;
                    },
                    { inserted: {}, failed: {} }
                );

                return (
                    <div
                        key={employeeNumber}
                        className="p-3 rounded mb-4"
                        style={{ backgroundColor: "#f7fafc" }}
                    >
                        <h3>
                            <span className="mr-3">
                                {employeeNumber === "emptyUser"
                                    ? t("other")
                                    : `${t("employee")} ${employeeNumber}`}
                            </span>

                            {status ? (
                                <>
                                    {!!Object.keys(inserted).length && (
                                        <span className="text-success mr-3">
                                            <FontAwesomeIcon icon={faCheck} />
                                            {Object.keys(inserted).length}
                                        </span>
                                    )}

                                    {!!Object.keys(failed).length && (
                                        <span className="text-danger mr-3">
                                            <FontAwesomeIcon icon={faClose} />
                                            {Object.keys(failed).length}
                                        </span>
                                    )}
                                </>
                            ) : (
                                <span className="text-danger">{message}</span>
                            )}
                        </h3>

                        {status && (
                            <div>
                                {!!Object.keys(failed).length && (
                                    <hr className="my-2" />
                                )}

                                {Object.keys(failed).map((row) => {
                                    return (
                                        <div key={row} className="text-danger">
                                            <b>{t("row-{{count}}", { count: row })}:</b>{" "}
                                            <span>{failed[row].message}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}

            {showCloseButton && (
                <div className="d-flex gap-x-4">
                    <Button color="danger" className="w-100" onClick={onClose}>
                        {t("close")}
                    </Button>
                </div>
            )}
        </div>
    );
}

export default ImportSummary;
